<template>
  <b-modal
    ref="modal-modeloenvioemail"
    scrollable
    centered
    :hide-footer="true"
    @hide="hideModal"
    @close="hideModal"
  >
    <template #modal-title>
      Selecione o modelo para o envio
    </template>

    <div>
      <label class="form-label">Deseja executar agora ou programar?</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="execute-now"
          value="now"
          v-model="executeOption"
        />
        <label class="form-check-label" for="execute-now">
          Executar agora
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="schedule"
          value="schedule"
          v-model="executeOption"
        />
        <label class="form-check-label" for="schedule">
          Programar
        </label>
      </div>
      <div v-if="currentRecurrence">
          <label class="form-label">Status</label>
          <ToogleSwitch v-model="status"/>
        </div>
    </div>

    <ModalPeriodicidade
      v-if="executeOption === 'schedule'"
      ref="ModalPeriodicidade"
      :trigger-generate="generateCronTrigger"
      @cron-generated="handleCronGenerated"
      :cron-expression="currentRecurrence ? currentRecurrence.cronPeriodicidade : null"
    />

    <BaseSelectModeloEnvio ref="BaseSelectModeloEnvio" @select="setValueOnData" :selected-modelo="data.modeloEnvioId" />

    <DefaultButton
      btnVariant="btn-third justify-content-center"
      :onClick="onCreateAcao"
      icon="fas fa-check-circle"
      text="Salvar"
    />
  </b-modal>
</template>

<script>
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import RecorrenciaListaInteligenteRepository from '@/shared/http/repositories/configurations/recorrenciaListaInteligente.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import BaseSelectModeloEnvio from '@/views/private/configurations/lista-inteligente/components/add/component/BaseSelectModeloEnvio.vue'
import ModalPeriodicidade from '../component/ModalPeriodicidade.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

const AcaoListaInteligenteData = {
  modeloEnvioId: null,
  acaoListaInteligente: 'SEND_EMAIL',
  cronExpression: ''
}

export default {
  name: 'SendEmailListaInteligenteModal',
  components: {
    DefaultButton,
    BaseSelectModeloEnvio,
    ModalPeriodicidade,
    ToogleSwitch
  },
  data () {
    return {
      data: AcaoListaInteligenteData,
      acaoListaId: null,
      executeOption: 'now',
      generateCronTrigger: false,
      status: false
    }
  },
  methods: {
    showModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.getRecorrencia()
        this.$refs['modal-modeloenvioemail'].show()
      }
    },
    hideModal () {
      this.$refs['modal-modeloenvioemail'].hide()
    },
    setValueOnData (modeloId) {
      this.data.modeloEnvioId = modeloId
    },
    onCreateAcao () {
      if (this.executeOption === 'schedule') {
        this.generateCronTrigger = true
        this.$nextTick(() => {
          this.generateCronTrigger = false
        })
      } else {
        this.finalizeCreateAcao()
      }
    },
    handleCronGenerated (cronExpression) {
      this.data.cronExpression = cronExpression
      const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'SEND_EMAIL')

      if (foundRecurrence) {
        this.updateRecorrencia()
        this.$emit('reloadAcoes')
      } else {
        this.createRecorrencia()
        this.$emit('reloadAcoes')
      }
    },
    finalizeCreateAcao () {
      if (this.data.modeloEnvioId) {
        loading.push()
        ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
          .then((response) => {
            if (response.status === 201) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.hideModal()
              this.$emit('reloadAcoes')
            }
            loading.close()
          })
          .catch(this.onException)
      }
    },
    createRecorrencia () {
      const payload = {
        listaInteligenteId: this.acaoListaId,
        modeloEnvioId: this.data.modeloEnvioId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente
      }

      RecorrenciaListaInteligenteRepository.Create(payload)
        .then((response) => {
          if (response.status === 201) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao criar recorrência:', error)
        })
    },
    getRecorrencia () {
      RecorrenciaListaInteligenteRepository.GetById(this.acaoListaId)
        .then((response) => {
          if (response.status === 200 && Array.isArray(response.data.content)) {
            this.recorrencia = response.data.content

            const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'SEND_EMAIL')

            if (foundRecurrence) {
              this.currentRecurrence = foundRecurrence
              this.executeOption = 'schedule'
              this.data.cronExpression = foundRecurrence.cronPeriodicidade
              this.editCronExpression = this.data.cronExpression
              this.data.modeloEnvioId = foundRecurrence.modeloEnvio.id
              this.status = foundRecurrence.status
            } else {
              this.currentRecurrence = null
              this.executeOption = 'now'
              this.data.cronExpression = null
              this.data.modeloEnvioId = null
            }
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar recorrência:', error)
        })
    },
    updateRecorrencia () {
      if (!this.currentRecurrence) {
        return
      }

      const payload = {
        id: this.currentRecurrence.id,
        listaInteligenteId: this.acaoListaId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente,
        modeloEnvioId: this.data.modeloEnvioId,
        status: this.status
      }
      RecorrenciaListaInteligenteRepository.Update(payload)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao atualizar recorrência:', error)
        })
    },
    toggleCreateUser () {
      this.status = !this.status
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/SendEmailListaInteligenteModal.vue